import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import http from 'hub-http/clients/apiClient';
import { ACADEMY_AI_SERVICE_URI } from '../../constants/ApiConstants';
const CALL_ACADEMY_AI = registerQuery({
  fieldName: 'callAcademyAi',
  args: ['query'],
  fetcher(args) {
    return http.post(`${ACADEMY_AI_SERVICE_URI}/v1/qa`, {
      data: {
        query: args.query,
        vaasTopK: 3
      }
    });
  }
});
export const useAcademyAi = ({
  prompt
}) => {
  const {
    data: academyAiData,
    loading: academyAiLoading,
    error: academyAiError
  } = useQuery(CALL_ACADEMY_AI, {
    skip: !prompt,
    variables: {
      query: prompt
    }
  });
  return {
    academyAiData,
    academyAiLoading,
    academyAiError
  };
};
export const GET_ACADEMY_AI_RECOMMENDATIONS_FOR_QUERY = registerQuery({
  fieldName: 'academyAiRecommendationsForQuery',
  args: ['query', 'language', 'numberOfResults'],
  fetcher({
    query,
    language,
    numberOfResults
  }) {
    return http.post(`${ACADEMY_AI_SERVICE_URI}/v1/vaas/recommendations/${language}`, {
      data: {
        query,
        numberOfResults
      }
    });
  }
});
export const useAiRecommendationsForQuery = ({
  skip,
  query,
  language,
  numberOfResults
}) => {
  const {
    data: recommendationsResponse,
    loading: recommendationsLoading,
    error: recommendationsError
  } = useQuery(GET_ACADEMY_AI_RECOMMENDATIONS_FOR_QUERY, {
    variables: {
      query,
      language,
      numberOfResults
    },
    skip
  });
  const {
    recommendations
  } = recommendationsResponse || {};
  return {
    recommendations,
    recommendationsLoading,
    recommendationsError
  };
};